var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5521_79)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.63301 2.06683H2.06634C1.87185 2.06683 1.68532 2.1441 1.5478 2.28162C1.41027 2.41915 1.33301 2.60567 1.33301 2.80017V7.9335C1.33301 8.12799 1.41027 8.31452 1.5478 8.45204C1.68532 8.58957 1.87185 8.66683 2.06634 8.66683H7.19967C7.39417 8.66683 7.58069 8.58957 7.71822 8.45204C7.85575 8.31452 7.93301 8.12799 7.93301 7.9335V5.36683",
    stroke: "white",
    strokeWidth: 0.916667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3832 1.51664C7.52907 1.37077 7.72691 1.28882 7.9332 1.28882C8.13949 1.28882 8.33733 1.37077 8.4832 1.51664C8.62907 1.6625 8.71102 1.86035 8.71102 2.06664C8.71102 2.27293 8.62907 2.47077 8.4832 2.61664L4.99987 6.09997L3.5332 6.46663L3.89987 4.99997L7.3832 1.51664Z",
    stroke: "white",
    strokeWidth: 0.916667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5521_79"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.8,
    height: 8.8,
    fill: "white",
    transform: "translate(0.599609 0.599976)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/iconEdit.0b7194fd7360feb0f897632df22480c5.svg";
export { ForwardRef as ReactComponent };